import axios from "axios";
import authActions from "./auth";
import appActions from "./app";
import { format } from "date-fns";


const setViewKiloDiarioModal = (value) => {
  return (dispatch) =>
    dispatch({ type: "VIEW_KILO_DIARIO_MODAL", payload: value });
};

const setViewMetaMensualModal = (value) => {
  return (dispatch) =>
    dispatch({ type: "VIEW_META_MENSUAL_MODAL", payload: value });
};

const buildQueryParams = (formData) => {
  const params = new URLSearchParams();
  if (formData.dateInit) {
    params.append("dateInit", format(new Date(formData.dateInit), "yyyy-MM-dd"));
  }
  if (formData.dateFinish) {
    params.append("dateFinish", format(new Date(formData.dateFinish), "yyyy-MM-dd"));
  }


  if (formData.locals.length > 0)
    params.append('local', formData.locals.join(','));

  if (formData.materials.length > 0)
    params.append('material', formData.materials.join(','));

  return params.toString();
};

const setFileNameForView = (baseName) => {
  const date = new Date();
  const formattedDate = format(date, "yyyy-MM-dd");
  return `${baseName}-${formattedDate}.xlsx`;
}

const downloadKiloDiario = (formData) => {
  return async (dispatch) => {
    try {
      dispatch(appActions.setLoading(true));
      const urlParams = buildQueryParams(formData);
      const serviceUrl = `/reports/admin/generateGreenPointRemovalViewReport?${urlParams}`;
      const response = await axios.get(serviceUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", setFileNameForView("kilo-diario"));
      document.body.appendChild(link);
      link.click();
      dispatch(appActions.setLoading(false));
    } catch (err) {
      console.log("Error downloading kilo diario:", err);
      dispatch(appActions.setLoading(false));
      dispatch(authActions.logoutIfNotAuth(err));
    }
  };
}

const downloadMetaMensual = (formData) => {
  return async (dispatch) => {
    try {
      dispatch(appActions.setLoading(true));
      const urlParams = buildQueryParams(formData);
      const serviceUrl = `/reports/admin/generateGreenPointMetaViewReport?${urlParams}`;
      const response = await axios.get(serviceUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", setFileNameForView("meta-mensual"));
      document.body.appendChild(link);
      link.click();
      dispatch(appActions.setLoading(false));
    } catch (err) {
      console.log("Error downloading meta mensual:", err);
      dispatch(appActions.setLoading(false));
      dispatch(authActions.logoutIfNotAuth(err));
    }
  };
}


export default {
  setViewKiloDiarioModal,
  setViewMetaMensualModal,
  downloadKiloDiario,
  downloadMetaMensual
}